import React from "react";
import { NavLink } from "react-router-dom";
import Cta from "../../components/cta/cta";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import Testimonials from "../../components/home/Testimonials";
import reviewBanner from "../../assets/images/review/review-banner.png";
import sfc from "../../assets/images/review/efc.png";
import apr from "../../assets/images/review/apr.png";
import prm from "../../assets/images/review/prm.png";

const ReviewPage = () => {
  return (
    <>
      <div className="sales-main-wrapper">
        <section className="sa-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h1 className="heading39px roboto-bold mb20 text-color-131415">
                    Ensure Guests Always Remember to Rate <br /> Their Stay
                  </h1>
                  <p className="heading16px roboto-regular mb30">
                    Send automated review reminders, use AI for drafting
                    responses, and protect your profile from retaliatory
                    feedback when giving critical reviews.
                  </p>

                  <ul className="btn-sec">
                    <li>
                      <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        {" "}
                        Subscribe Now
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/contact-us"}
                        className="common-btn-class transparentBtn roboto-regular"
                      >
                        Contact us
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={reviewBanner}
                    className="img-responsive"
                    alt="The Ultimate Tool for Sales Professionals"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb10 heading29px mb60 text-center">
                Elevate Guest Experiences with <br /> Smart Feedback Management
              </h2>
              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Streamline Feedback Collection
                  </h3>
                  <p className="heading16px roboto-regular">
                    Capture guest insights effortlessly with automated surveys
                    and QR code scans. BeyondLeadz sends timely review
                    reminders, ensuring every guest’s voice is heard and helping
                    you build trust and loyalty. Simplifying the review process
                    encourages more guests to share valuable feedback.
                  </p>
                </div>
                <div>
                  <img
                    src={sfc}
                    alt="Streamline Feedback Collection"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="block-order2">
                  <img
                    src={apr}
                    alt="Personalized Responses with AI"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    AI-Driven Personalized Responses
                  </h3>
                  <p className="heading16px roboto-regular">
                    Use AI to create tailored replies to guest reviews, saving
                    time and maintaining engagement. BeyondLeadz’s AI generates
                    thoughtful responses, ensuring guest satisfaction and
                    highlighting your dedication to service. With routine
                    responses automated, your team can focus on delivering
                    exceptional guest experiences.
                  </p>
                </div>
              </div>

              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Proactive Reputation Management
                  </h3>
                  <p className="heading16px roboto-regular">
                    Address guest concerns promptly to prevent negative reviews.
                    BeyondLeadz alerts your team to potential issues, allowing
                    swift intervention. This approach helps maintain a positive
                    reputation and demonstrates your commitment to guest
                    satisfaction.
                  </p>
                </div>
                <div>
                  <img
                    src={prm}
                    alt="Proactive Reputation Management"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default ReviewPage;
